export default function ResultsSection() {
  const results = [
    {
      student: '中2 Aさん',
      subject: '数学',
      before: '45点',
      after: '82点',
      improvement: '+37点',
      comment: '基礎から丁寧に教えてもらい、苦手だった数学が得意科目になりました。'
    },
    {
      student: '中3 Bくん',
      subject: '英語',
      before: '52点',
      after: '88点',
      improvement: '+36点',
      comment: '文法の理解が深まり、長文問題も解けるようになりました。'
    },
    {
      student: '中1 Cさん',
      subject: '5教科合計',
      before: '298点',
      after: '412点',
      improvement: '+114点',
      comment: '勉強の仕方がわかり、全教科の成績が上がりました。'
    },
    {
      student: '中3 Dくん',
      subject: '理科',
      before: '38点',
      after: '76点',
      improvement: '+38点',
      comment: '実験や図の見方を教えてもらい、理科が楽しくなりました。'
    },
    {
      student: '中2 Eさん',
      subject: '国語',
      before: '55点',
      after: '85点',
      improvement: '+30点',
      comment: '読解のコツを掴んで、記述問題も書けるようになりました。'
    },
    {
      student: '中3 Fくん',
      subject: '社会',
      before: '48点',
      after: '82点',
      improvement: '+34点',
      comment: '暗記だけでなく、理解して覚えられるようになりました。'
    }
  ];

  const achievements = [
    { number: '95%', label: '成績アップ率', description: '入塾後3ヶ月以内' },
    { number: '平均+32点', label: '定期テスト', description: '入塾前との比較' },
    { number: '100%', label: '志望校合格率', description: '過去3年間の実績' },
    { number: '200名+', label: '指導実績', description: '開校以来の累計' }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a2332] mb-4">
            成績アップ実績
          </h2>
          <p className="text-gray-600 text-lg">
            NICKで学んだ生徒たちの変化
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {achievements.map((achievement, index) => (
            <div
              key={index}
              className="bg-[#faf8f5] rounded-3xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <p className="text-5xl font-bold text-[#4a90e2] mb-3">
                {achievement.number}
              </p>
              <p className="text-xl font-semibold text-[#1a2332] mb-2">
                {achievement.label}
              </p>
              <p className="text-sm text-gray-600">
                {achievement.description}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {results.map((result, index) => (
            <div
              key={index}
              className="bg-[#faf8f5] rounded-3xl p-8 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <p className="text-sm font-semibold text-gray-600">
                  {result.student}
                </p>
                <span className="bg-[#4a90e2]/10 text-[#4a90e2] px-4 py-1 rounded-full text-sm font-semibold">
                  {result.subject}
                </span>
              </div>

              <div className="flex items-center justify-center gap-4 mb-6">
                <div className="text-center">
                  <p className="text-sm text-gray-600 mb-1">入塾前</p>
                  <p className="text-3xl font-bold text-gray-400">
                    {result.before}
                  </p>
                </div>

                <i className="ri-arrow-right-line text-3xl text-[#4a90e2]"></i>

                <div className="text-center">
                  <p className="text-sm text-gray-600 mb-1">入塾後</p>
                  <p className="text-3xl font-bold text-[#4a90e2]">
                    {result.after}
                  </p>
                </div>
              </div>

              <div className="bg-[#4a90e2] text-white text-center py-3 rounded-2xl mb-4">
                <p className="text-2xl font-bold">{result.improvement}</p>
              </div>

              <p className="text-sm text-gray-600 leading-relaxed">
                {result.comment}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6 max-w-3xl mx-auto leading-relaxed">
            <strong>廿日市市</strong>の学習塾NICKでは、<strong>定期テスト対策</strong>と<strong>高校受験対策</strong>を通じて、多くの中学生が<strong>成績アップ</strong>を実現しています。一人ひとりの学習状況に合わせた<strong>個別指導</strong>と<strong>少人数指導</strong>で、確実な結果を出しています。
          </p>
        </div>
      </div>
    </section>
  );
}
